/*
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 15:09:29
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-11-08 19:56:03
 */
import ColumnTypes from "@/utils/ColumnTypes";
import {palletStatus} from '@/utils/dataMap';

const id = {
    key: 'id',
    label: '货盘表ID',
    type: ColumnTypes.TextCell,
    module: 'input',
    isSearch: true,
    minWidth: '100',
    searchKey: 'pallet_id',
    searchIndex: 2,
    fixed: 'left'
};
const pallet_name = {
    key: 'pallet_name',
    label: '货盘表格名称',
    type: ColumnTypes.TextCell,
    isSearch: true,
    searchIndex: 1,
    module: 'input',
    minWidth: '100'
}
const status_text = {
    key: 'status_text',
    label: '上传状态',
    minWidth: '120',
    isSearch: true,
    module: 'select',
    searchIndex: 4,
    searchKey: 'pallet_status',
    selectList: palletStatus,
    type: ColumnTypes.TextCell,
}
const add_time = {
    key: 'add_time',
    label: '上传时间',
    minWidth: '150',
    module: 'date',
    isSearch: true,
    searchIndex: 0,
    block: true,
    searchKey: ['add_time_start', 'add_time_end'],
    type: ColumnTypes.TextCell,
}
const remark = {
    key: 'remark',
    label: '备注',
    type: ColumnTypes.TextCell,
    minWidth: '120'
}

const operations = {
    key: 'operations',
    label: '操作',
    width: '140',
    fixed: 'right',
    headerAlign: 'right',
    align: 'right',
    type: ColumnTypes.ButtonsCell
}

const pallutInfo = {
    key: 'pallutinfo',
    label: '货盘信息',
    minWidth: '200',
    type: ColumnTypes.PallutInfoCell
}
const pallutUploadNumb = {
    key: 'pallutUploadNumb',
    label: '上传数量',
    minWidth: '100',
    type: ColumnTypes.PallutUploadNumbCell
}
const pallutUploadStatus = {
    key: 'pallutUploadStatus',
    label: '上传状态',
    minWidth: '100',
    type: ColumnTypes.PallutUploadStatusCell
}
const pallutContactInfo = {
    key: 'pallutContactInfo',
    label: '联系人信息',
    minWidth: '200',
    type: ColumnTypes.PallutContactInfoCell
}
export const columns = [
    pallutInfo,
    pallutUploadNumb,
    pallutUploadStatus,
    pallutContactInfo,
    remark,
    operations
];

export const searchColumns = [
    id,
    pallet_name,
    status_text,
    add_time
]